import { render, staticRenderFns } from "./BranchModal.vue?vue&type=template&id=0a6a2d9c&scoped=true"
import script from "./BranchModal.vue?vue&type=script&lang=js"
export * from "./BranchModal.vue?vue&type=script&lang=js"
import style0 from "./BranchModal.vue?vue&type=style&index=0&id=0a6a2d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a2d9c",
  null
  
)

export default component.exports